import { color, ColorHelper } from 'csx';

export const colorBrand: ColorHelper =
  color('#4a00ff');

export const colorContrast: ColorHelper =
  color('#ff056d');

export const colorWhite: ColorHelper =
  color('#ffffff');

export const colorBlack: ColorHelper =
  color('#000000');

export const colorError: ColorHelper =
  color('#ff0550');

export const colorGoogle: ColorHelper =
  color('#dd4b39');

export const colorSlate: ColorHelper =
  color('#2e2e3b');

export const colorGradientTop: ColorHelper =
  color('#D62727');

export const colorSubtle: ColorHelper =
  color('#7b858a');

export const colorTertiary: ColorHelper =
  color('#ccd0d2');

export const colorBackground: ColorHelper =
  color('#e0e5e9');

export const colorBackgroundAlt: ColorHelper =
  color('#f5f7f8');

export const colorInfo: ColorHelper =
  color('#00b5ee');

export const colorWarning: ColorHelper =
  color('#eebb28');

export const colorGold: ColorHelper =
  color('#f5d53f');

export const colorAppHeaderBackground =
  color('rgba(0,0,0,0.5)');

export const colorGradientHeroCenter: ColorHelper =
  colorError;

export const colorGradientHeroMid: ColorHelper =
  color('rgba(0, 49, 255, 0.51)');

export const colorGradientHeroOuter: ColorHelper =
  color('rgba(0, 31, 255, 0.3)');

export const colorGradientHeroBackgroundCenter: ColorHelper =
  colorError;

export const colorGradientHeroBackgroundMid: ColorHelper =
  color('rgb(0, 49, 255)');

export const colorGradientHeroBackgroundOuter: ColorHelper =
  color('rgb(0, 31, 255)');

export const colorGradientPricingCenter: ColorHelper =
  colorError;

export const colorGradientPricingMid: ColorHelper =
  color('rgba(0, 49, 255, 0.85)').darken(.3);

export const colorGradientPricingOuter: ColorHelper =
  color('rgba(0, 31, 255, 0.6)').darken(.2);


/* 3rd party brand colours */
export const colorYouTube: ColorHelper =
  color('#ff0000');

export const colorSpotify: ColorHelper =
  color('#1DB954');

export const colorTwitter: ColorHelper =
  color('#1da1f2');

export const colorDropbox: ColorHelper =
  color('#007ee5');

export const colorFacebook: ColorHelper =
  color('#3b5998');

export const colorMastercard: ColorHelper =
  color('#eb001b');

export const colorLinkedIn: ColorHelper =
  color('#0077B5');

export const colorInstagram: ColorHelper =
  color('#E4405F');

export const colorSignInInfo: ColorHelper =
    color('#841199');